import { useSelector } from 'react-redux';

import { getTimezone } from '../../../selectors/hubSelector';

const useTimezone = () => {
  return useSelector(getTimezone);
};

export default useTimezone;
